import React, { useEffect, useState } from "react";
import axios from "../../api/axios.js";
import {
  convertIntoSelect2Options,
  getFetchOptions,
} from "../../js/utility.js";
import Breadcrumb from "../utils/Breadcrumb.jsx";
import Select from "react-select";

const SchoolsLayout = () => {
  const initialFormData = {
    codmiur: "",
    tipologia: "",
    denomistituto: "",
    indirizzo: "",
    idprovincia: null,
    idcomune: null,
    cityOptions: [],
  };
  const [formData, setFormData] = useState({ ...initialFormData });
  const [oldFormData, setOldFormData] = useState({ ...initialFormData });
  const [provsOption, setProvsOption] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState("");
  const [cityOption, setCityOption] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedCodMiur, setSelectedCodMiur] = useState("");
  const [selectedName, setSelectedName] = useState("");
  const [schools, setSchools] = useState([]);
  const [showDetails, setShowDetails] = useState(false);
  const [schoolTypes, setSchoolTypes] = useState([
    { label: "Liceo Scientifico", value: "Liceo Scientifico" },
    {
      label: "Liceo Scientifico con opzione Scienze Applicate",
      value: "Liceo Scientifico - Scienze Applicate",
    },
    {
      label: "Liceo Scientifico con opzione Sportiva",
      value: "Liceo Scientifico - Sportivo",
    },
    { label: "Liceo Classico", value: "Liceo Classico" },
    { label: "Liceo Linguistico", value: "Liceo Linguistico" },
    { label: "Liceo delle Scienze Umane", value: "Liceo delle Scienze Umane" },
    {
      label: "Liceo delle Scienze Umane con opzione Economico-Sociale",
      value: "Liceo Economico-Sociale",
    },
    { label: "Liceo Artistico", value: "Liceo Artistico" },
    { label: "Liceo Musicale", value: "Liceo Musicale" },
    { label: "Liceo Coreutico", value: "Liceo Coreutico" },

    {
      label: "Istituto Tecnico Economico",
      value: "Istituto Tecnico Economico",
    },
    {
      label: "Istituto Tecnico Tecnologico",
      value: "Istituto Tecnico Tecnologico",
    },
    { label: "Istituto Tecnico Agrario", value: "Istituto Tecnico Agrario" },
    {
      label: "Istituto Tecnico per il Turismo",
      value: "Istituto Tecnico per il Turismo",
    },
    {
      label: "Istituto Tecnico Commerciale",
      value: "Istituto Tecnico Commerciale",
    },
    {
      label: "Istituto Tecnico Industriale",
      value: "Istituto Tecnico Industriale",
    },

    {
      label:
        "Istituto Professionale per i Servizi Alberghieri e della Ristorazione",
      value: "Istituto Alberghiero",
    },
    {
      label: "Istituto Professionale per i Servizi Commerciali",
      value: "Istituto Servizi Commerciali",
    },
    {
      label: "Istituto Professionale per la Sanità e l'Assistenza Sociale",
      value: "Istituto Professionale Sanità",
    },
    {
      label: "Istituto Professionale per l'Artigianato",
      value: "Istituto Professionale Artigianato",
    },
    {
      label: "Istituto Professionale per l'Industria e l'Artigianato",
      value: "Istituto Professionale Industria e Artigianato",
    },

    {
      label: "Centro di Formazione Professionale (CFP)",
      value: "Centro di Formazione Professionale",
    },
  ]);

  const [selectedImportFile, setSelectedImportFile] = useState(null);

  const [lastOperation, setLastOperation] = useState("");

  const breadcrumb = {
    current_section: "Gestione scuole",
    sections: [
      { name: "Scuole", route_name: null, params: [] },
      { name: "Gestione scuole", route_name: null, params: [] },
    ],
  };

  useEffect(() => {
    const fetchSchools = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/scuola`,
          fetchOptions
        );
        const result = await response.json();
        setSchools(result.return.scuola);
      } catch (error) {
        console.error(error);
      }
    };

    const fetchProvs = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/provincie`,
          fetchOptions
        );
        const result = await response.json();

        result.provincie.sort((a, b) => a.nome.localeCompare(b.nome));

        setProvsOption(
          convertIntoSelect2Options(result.provincie, "id", "nome")
        );
      } catch (error) {
        console.error(error);
      }
    };

    fetchSchools();
    fetchProvs();
  }, []);

  useEffect(() => {
    handleEditProvinceChange(formData?.idprovincia);
  }, [formData?.idprovincia]);

  const handleToggleDetails = (operation, id = null) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (id && operation === "edit") {
      const fetchSchool = async () => {
        try {
          const fetchOptions = getFetchOptions(
            "application/x-www-form-urlencoded",
            [],
            "GET"
          );
          const response = await fetch(
            `${axios.defaults.baseURL}/scuola?idscuola=${id}`,
            fetchOptions
          );
          const result = await response.json();
          setFormData(result.return.scuola[0]);
          setOldFormData(result.return.scuola[0]);
        } catch (error) {
          console.error(error);
        }
      };

      fetchSchool();
      setShowDetails(true);
    }
    if (operation === "add") {
      setShowDetails(!showDetails);
    }
    setLastOperation(operation);
  };

  const handleCodMiurChange = (event) => {
    setSelectedCodMiur(event.target.value);

    if (event.target.value != "") {
      setSelectedCity(null);
      setSelectedProvince(null);
    }
  };

  const handleProvinceChange = (event) => {
    setSelectedProvince(event?.value);
    setSelectedCodMiur(null);

    const fetchCities = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/app/getTowns?idprov=${event?.value}`,
          fetchOptions
        );
        const result = await response.json();

        setCityOption(convertIntoSelect2Options(result, "id", "nome"));
      } catch (error) {
        console.error(error);
      }
    };

    fetchCities();
  };

  const handleCityChange = (event) => {
    setSelectedCity(event?.value);
  };

  const handleSearch = () => {
    const fetchFilteredSchools = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getAllSchools?codmiur=${
            selectedCodMiur ?? ""
          }&denomistituto=${selectedName ?? ""}&townId=${
            selectedCity ?? ""
          }&provinceId=${selectedProvince ?? ""}`,
          fetchOptions
        );
        const result = await response.json();

        if (result.error) {
          alert("Nessun risultato trovato.");
          setSchools([]);
          return;
        }

        setSchools(result);
      } catch (error) {
        console.error(error);
      }
    };

    fetchFilteredSchools();
  };

  const handleSave = async () => {
    if (!formData.codmiur) {
      alert("Il campo 'Codice MIUR' è obbligatorio.");
      return;
    }
    if (!formData.tipologia) {
      alert("Il campo 'Tipologia' è obbligatorio.");
      return;
    }
    if (!formData.denomistituto) {
      alert("Il campo 'Nome' è obbligatorio.");
      return;
    }
    if (!formData.indirizzo) {
      alert("Il campo 'Indirizzo' è obbligatorio.");
      return;
    }
    if (!formData.idprovincia) {
      alert("Il campo 'Provincia' è obbligatorio.");
      return;
    }
    if (!formData.idcomune) {
      alert("Il campo 'Comune' è obbligatorio.");
      return;
    }

    if (
      formData.codmiur !== oldFormData.codmiur &&
      formData.codmiur !== "" &&
      formData.codmiur !== null
    ) {
      const responseCheckMiur = await fetch(
        `${axios.defaults.baseBFFUrl}/fe/checkSchoolCodMiur?miurCode=${formData.codmiur}`,
        getFetchOptions("application/x-www-form-urlencoded", [], "GET")
      );
      const resultCheckMiur = await responseCheckMiur.json();

      if (resultCheckMiur.error == "Token non valido") {
        alert("Token non valido. Riprova a fare il login.");
        return;
      }

      if (resultCheckMiur.exists) {
        alert(
          "Il codice MIUR inserito non è valido o è già associato a un'altra scuola."
        );
        return;
      }
    }

    if (lastOperation === "add") {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          formData,
          "POST"
        );
        const response = fetch(
          `${axios.defaults.baseURL}/scuola`,
          fetchOptions
        );
        window.location.reload();
      } catch (error) {
        console.error(error);
      }
    }

    if (lastOperation === "edit") {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          Object.entries(formData).reduce(
            (a, [k, v]) => (v === null ? a : { ...a, [k]: v }),
            {}
          ),
          "PUT"
        );
        const response = fetch(
          `${axios.defaults.baseURL}/scuola`,
          fetchOptions
        );

        window.location.reload();
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleAddProvinceChange = (event) => {
    formData.idprovincia = event?.value;
    const fetchCities = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/app/getTowns?idprov=${event?.value}`,
          fetchOptions
        );
        const result = await response.json();
        formData.cityOptions = convertIntoSelect2Options(result, "id", "nome");
        setFormData({ ...formData });
      } catch (error) {
        console.error(error);
      }
    };

    fetchCities();
    setFormData({ ...formData });
  };

  const handleEditProvinceChange = (id) => {
    const fetchCities = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/app/getTowns?idprov=${id}`,
          fetchOptions
        );
        const result = await response.json();

        setFormData({
          ...formData,
          cityOptions: convertIntoSelect2Options(result, "id", "nome"),
        });
      } catch (error) {
        console.error(error);
      }
    };

    fetchCities();
  };

  const handleAddCityChange = (event) => {
    formData.idcomune = event?.value;
    setFormData({ ...formData });
  };

  const handleAddCodMiurChange = (event) => {
    formData.codmiur = event.target.value;
    setFormData({ ...formData });
  };

  const handleAddTipologiaChange = (event) => {
    formData.tipologia = event?.value;
    setFormData({ ...formData });
  };

  const handleAddNameChange = (event) => {
    formData.denomistituto = event.target.value;
    setFormData({ ...formData });
  };

  const handleAddAddressChange = (event) => {
    formData.indirizzo = event.target.value;
    setFormData({ ...formData });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedImportFile(file);
  };

  const handleFileUpload = (event) => {
    if (!selectedImportFile) {
      alert("Per favore, seleziona un file da importare.");
      return;
    }
    if (
      !window.confirm(
        "ATTENZIONE! Il caricamento di un nuovo file potrebbe sovrascrivere i dati esistenti. Sei sicuro di voler procedere?"
      )
    ) {
      return;
    }

    const sendCsvToBFF = async () => {
      try {
        const formData = new FormData();
        formData.append("file", selectedImportFile);
        formData.append("token", localStorage.getItem("token"));

        const fetchOptions = {
          method: "POST",
          body: formData,
          headers: {},
        };

        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/upload-csv`,
          fetchOptions
        );
        if (!response.ok) throw new Error("Errore nell'upload");

        const result = await response.json();
        alert(`Caricamento completato con successo!`);
      } catch (error) {
        console.error(error);
      }
    };

    sendCsvToBFF();
  };

  return (
    <div className="container-fluid">
      {/* Breadcrumb Component */}
      <Breadcrumb breadcrumb={breadcrumb} />

      <br />
      <label className="mb-4">
        <b>(*) Campo obbligatorio</b>
      </label>

      <div className="card custom-card">
        <div className="card-header">
          Inserisci scuole{" "}
          <span className="text-danger">
            ( Il formato del file accettato è .csv )
          </span>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col">
              <div className="input-group">
                <input
                  type="file"
                  className="form-control"
                  id="inputGroupFile04"
                  aria-describedby="inputGroupFileAddon04"
                  aria-label="Upload"
                  onChange={handleFileChange}
                  accept=".csv"
                />
                <button
                  className="btn btn-success"
                  type="button"
                  id="inputGroupFileAddon04"
                  onClick={handleFileUpload}
                >
                  <i className="bi bi-file-excel-fill"></i> Importa
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* General Data Card */}
      <div
        className={!showDetails ? "d-none" : "card card-body"}
        style={{ backgroundColor: "#e3f4ec" }}
      >
        <div className="card-header">Gestione scuole</div>
        <form id="schoolForm">
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-4">
                <label htmlFor="codmiur">
                  Codice MIUR <b>*</b>
                </label>
                <input
                  className="form-control"
                  id="codmiur"
                  name="codmiur"
                  label="Codice MIUR"
                  value={formData?.codmiur}
                  onChange={handleAddCodMiurChange}
                  required
                  disabled={lastOperation === "edit"}
                />
              </div>
              <div className="col-4">
                <label htmlFor="type">
                  Tipologia <b>*</b>
                </label>
                <Select
                  options={schoolTypes}
                  id="tipologia"
                  name="tipologia"
                  value={
                    schoolTypes.find(
                      (option) => option.value === formData.tipologia
                    ) || null
                  }
                  onChange={handleAddTipologiaChange}
                  classNames={"form-control"}
                  placeholder="Scegli tipologia..."
                  isSearchable
                  isClearable
                />
              </div>
              <div className="col">
                <label htmlFor="denomistituto">
                  Nome <b>*</b>
                </label>
                <input
                  className="form-control"
                  id="denomistituto"
                  name="denomistituto"
                  value={formData?.denomistituto}
                  onChange={handleAddNameChange}
                />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col">
                <label htmlFor="indirizzo">
                  Indirizzo <b>*</b>
                </label>
                <input
                  className="form-control"
                  id="indirizzo"
                  name="indirizzo"
                  value={formData?.indirizzo}
                  onChange={handleAddAddressChange}
                />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col">
                <label htmlFor="province">
                  Provincia <b>*</b>
                </label>
                <Select
                  options={provsOption}
                  id="province"
                  name="province"
                  value={
                    provsOption.find(
                      (option) => option.value === Number(formData.idprovincia)
                    ) || null
                  }
                  onChange={handleAddProvinceChange}
                  classNames={"form-control"}
                  placeholder="Scegli provincia..."
                  isSearchable
                  isClearable
                />
              </div>
              <div className="col">
                <label htmlFor="city">
                  Comune <b>*</b>
                </label>
                <Select
                  options={formData?.cityOptions}
                  id="city"
                  name="city"
                  value={formData?.cityOptions?.filter(function (option) {
                    return option.value === Number(formData.idcomune);
                  })}
                  onChange={handleAddCityChange}
                  classNames={"form-control"}
                  placeholder="Scegli comune..."
                  isSearchable
                  isClearable
                />
              </div>
            </div>

            <div className="saveButtonContainer">
              <button
                type="button"
                className="btn btn-secondary me-2"
                onClick={() => {
                  setShowDetails(false);
                  setFormData({ ...initialFormData });
                }}
              >
                Chiudi
              </button>
              <div
                id="saveSchoolBtn"
                className="btn btn-success saveButton"
                role="button"
                onClick={handleSave}
              >
                &nbsp;Salva
              </div>
            </div>
          </div>
        </form>
      </div>

      {/* Filters */}
      <div className="card custom-card">
        <div className="card-header">Provincia e comune</div>
        <div className="card-body">
          <div className="row align-items-center">
            <div className="col-12 col-xl-2">
              <label htmlFor="codmiur">Codice MIUR</label>
              <input
                className="form-control"
                id="codmiur"
                name="codmiur"
                label="Codice MIUR"
                value={selectedCodMiur}
                onChange={handleCodMiurChange}
                placeholder="ZB123456"
                readOnly={
                  selectedProvince !== "" &&
                  selectedProvince !== null &&
                  selectedProvince !== undefined
                }
              />
            </div>
            <div className="col-12 col-xl-2">
              <label htmlFor="denomistituto">Nome</label>
              <input
                className="form-control"
                id="denomistituto"
                name="denomistituto"
                value={selectedName}
                onChange={(e) => setSelectedName(e.target.value)}
                placeholder="Nome scuola"
              />
            </div>

            <div className="col-12 col-xl-3">
              <label htmlFor="province">Provincia</label>
              <Select
                options={provsOption}
                id="province"
                name="province"
                value={provsOption.filter(function (option) {
                  return option.value === selectedProvince;
                })}
                onChange={handleProvinceChange}
                classNames={"form-control"}
                placeholder="Scegli provincia..."
                isSearchable
                isClearable
                isDisabled={selectedCodMiur !== "" && selectedCodMiur !== null}
              />
            </div>
            <div className="col-12 col-xl-3">
              <label htmlFor="city">Comune</label>
              <Select
                options={cityOption}
                id="city"
                name="city"
                value={cityOption?.filter(function (option) {
                  return option.value === selectedCity;
                })}
                onChange={handleCityChange}
                classNames={"form-control"}
                placeholder="Scegli comune..."
                isSearchable
                isClearable
                isDisabled={selectedCodMiur !== "" && selectedCodMiur !== null}
              />
            </div>
            {/* Search Button */}
            <div className="col-12 col-xl-2 mt-3">
              <div className="form-group">
                <button
                  id="btnSearch"
                  name="btnSearch"
                  className="searchButton btn btn-success w-100"
                  type="button"
                  onClick={handleSearch}
                >
                  &nbsp;Cerca
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Lista scuole */}
      <div className="card custom-card">
        <div className="card-header">
          <div className="d-flex justify-content-between align-items-center w-100">
            <div>Elenco scuole</div>
            <div>
              <div className="d-flex justify-content-end">
                <div className="saveButtonContainer">
                  <div
                    id="addSchoolBtn"
                    className="btn btn-success saveButton"
                    role="button"
                    onClick={() => handleToggleDetails("add")}
                  >
                    &nbsp;Aggiungi
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table
              className="table text-nowrap table-bordered"
              id="datatable-basic"
            >
              <thead>
                <tr>
                  <th scope="col" width="10"></th>
                  <th scope="col">Istituto</th>
                  <th scope="col">Nome</th>
                  <th scope="col">Indirizzo</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {schools &&
                  schools?.map((school, index) => (
                    <tr key={school.id}>
                      <td>{index + 1}</td>
                      <td>{school.tipologia}</td>
                      <td>{school.denomistituto}</td>
                      <td>{school.indirizzo}</td>
                      <td>
                        <div className="btn-list">
                          <button
                            className="btn btn-sm btn-warning"
                            onClick={() =>
                              handleToggleDetails("edit", school.id)
                            }
                          >
                            <i className="align-middle bi bi-pencil"></i>
                          </button>
                          <button className="btn btn-sm btn-danger">
                            <i className="align-middle bi bi-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SchoolsLayout;
